export const LEAD_FORM = "leadForm";
export const LEAD_INFO = "leadInfo";